export default __webpack_public_path__ + "static/media/Phone2.030748c8.png";